import { DOMEventDispatcher } from 'apps/webcomponents/src/utils/event.utils';
import { LitElement, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { GridTitleConfig } from '../types';
import { styles } from '../view/styles';

export class GridViewTitleWebComponent extends LitElement {
  @property({ type: Object })
  public config: GridTitleConfig;

  @property({ type: Boolean, attribute: true, reflect: true })
  public noEscapeSpaceInTitle = false;

  static get styles() {
    return styles;
  }

  private dispatchGlobalEvent(eventName?: string): void {
    if (!eventName) {
      return;
    }

    DOMEventDispatcher.dispatchGlobalEvent(this, eventName);
  }

  private getLinkTemplate(title: string): TemplateResult {
    return html` <gz-link class="title-link" id="title-link" showIcon> ${this.getTitle(title)} </gz-link> `;
  }

  /**
   * Title is set in a span element avoiding any spaces since white-space pre css can be added to it.
   * @param title
   * @returns TemplateResult
   */
  private getTitle(title: string): TemplateResult {
    return html`<span class="title">${title}</span>`;
  }

  protected render(): TemplateResult {
    return html`
      <gz-title fontWeight="500" fontsize="18" @click=${() => this.dispatchGlobalEvent(this.config?.event?.click)}>
        ${this.config?.isLink ? this.getLinkTemplate(this.config?.title) : this.getTitle(this.config?.title)}
      </gz-title>
    `;
  }
}
